// extracted by mini-css-extract-plugin
export default {"root":"Yb2rHUbjnL"};